<template>
  <div style="width:181px;">
    <v-list
      dense
      width="181px"
      max-height="354px"
    >
      <v-text-field
        v-if="searchable"
        :value="search"
        clearable
        :loading="searchLoading"
        placeholder="Search"
        dense
        :hide-details="true"
        class="px-4 py-1"
        clear-icon="$faTimes"
        @click:clear="onClearSearch"
        @input="handleSearch"
      />
      <template v-if="loading">
        <v-skeleton-loader
          type="list-item@4"
          class="mb-4"
        />
      </template>
      <template v-else>
        <div style="max-height:200px;overflow-y:auto;">
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            link
            @click="setSelected(i)"
          >
            <v-list-item-action class="mr-1 mb-1">
              <v-checkbox
                v-model="selected[i]"
                :ripple="false"
                color="success"
                @click.stop.prevent
              />
            </v-list-item-action>
            <v-list-item-title
              color="muted"
              class="mt-2"
              style="cursor: pointer;"
            >
              {{ item.name }}
            </v-list-item-title>
          </v-list-item>
        </div>
        <div
          class="subtext mt-5 mb-2"
        >
          {{ subtext }}
        </div>
      </template>
      <v-btn
        color="primary"
        class="d-block mx-auto"
        :disabled="disableSubmit"
        @click="submitFilters"
      >
        Apply
      </v-btn>
    </v-list>
  </div>
</template>

<script>
  export default {
    name: 'AsyncMultiselectFilter',
    props: {
      filterKey: String,
      listName: String,
      filterPayload: Object,
      searchable: {
        type: Boolean,
        default: true,
      },
      fetchFunction: {
        type: Function,
        default: () => new Promise((resolve, reject) => resolve()),
      },
    },
    data () {
      return {
        items: [],
        selected: [],
        loading: false,
        error: false,
        submitting: false,
        search: '',
        searchLoading: false,
      }
    },
    computed: {
      subtext () {
        if (this.items.length) {
          return `${this.selected.filter(item => !!item).length}/${this.items.length} selected`
        } return 'No filters found'
      },
      disableSubmit () {
        return this.searchLoading || this.loading || !this.items.length
      },
    },
    mounted () {
      this.initializeItems()
    },
    methods: {
      fetchFilterItems (payload) {
        return this.fetchFunction(payload)
      },
      initializeItems () {
        this.loading = true
        this.fetchFilterItems(this.filterPayload)
          .then((res) => { this.items = res.data.data })
          .finally(() => { this.loading = false })
      },
      handleSearch (input) {
        this.search = input
        this.searchLoading = true
        if (this.debounceId) clearTimeout(this.debounceId)
        this.debounceId = setTimeout(() => {
          this.fetchFilterItems({ ...this.filterPayload, search: this.search.trim() })
            .then((res) => { this.items = res.data.data })
            .finally(() => { this.searchLoading = false; this.loading = false })
        }, 500)
      },
      onClearSearch () {
        this.search = ''
        this.searchLoading = false
        this.initializeItems()
      },
      setSelected (idx) {
        if (this.selected[idx]) {
          this.selected[idx] = false
        } else {
          this.selected[idx] = true
        }
        this.$forceUpdate()
      },
      submitFilters () {
        const selectedFilters = this.items.reduce((acc, item, i) => this.selected[i] ? [item.value, ...acc] : acc, [])
        const payload = { key: this.filterKey, operator: 'in', value: selectedFilters.join(',') }
        this.$emit('apply-multiselect', payload)
        // Force closes menu after selection
        this.$parent.$parent.save()
      },
    },
  }
</script>

<style scoped>
.subtext {
  text-align: center;
  color: #535353;
  font-family: "Degular", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.382511px;
}
</style>
